import styled, { css } from 'styled-components';
import { applyStyleModifiers } from 'styled-components-modifiers';
import { NavLink as RouterNavLink, Link as RouterLink } from 'react-router-dom';

// Import utilities
import { customResponsive, getNavLinkUnderline } from 'components/styles';

const LIST_MODIFIERS = {
	searchPage: () => css`
		padding-top: 0.8rem;
	`
};

const ITEM_MODIFIERS = {
	searchPage: () => css`
		padding: 0 1.6rem;
	`,
	distinctive: () => css`
		padding: 0 1.6rem;
		margin: 0 0.25rem;
	`
};

const NAV_LINK_MODIFIERS = {
	searchPage: ({ theme }) => css`
		&:link,
		&:visited {
			padding: 0.9rem;
			font-size: 1.6rem;

			&::after {
				height: 2px;
			}

			&:hover {
				color: ${theme.white};
			}
		}
	`,
	distinctive: ({ theme }) => css`
		&:link,
		&:visited {
			padding: 0.2rem 2rem;
			font-size: 1.4rem;
			border: 1px solid ${theme.yellow};
			color: ${theme.yellow};
			border-radius: 0.5rem;
		}

		&.active-nav {
			&:link,
			&:visited {
				color: ${theme.nav.menuActiveTextDistintive};
				background-color: ${theme.yellow}
				&::after {
					content: none;
				}
			}
		}

		&:hover {
			color: ${theme.nav.menuActiveTextDistintive};
				background-color: ${theme.yellow}
		}
	`
};

const linkStyle = css`
	&:link,
	&:visited {
		position: relative;
		display: flex;
		align-items: center;
		padding: 0.75rem 1.3rem;
		color: ${({ theme }) => theme.grayMedium};
		font-size: 1.4rem;
		transition: all 0.3s ease-in-out;

		&::after {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			bottom: 0;
			height: 4px;
			width: 100%;
			transform: scaleX(0);
			transform-origin: 0% 50%;
			transition: all 0.3s ease-in-out;
			${getNavLinkUnderline()}
		}
	}

	&.active-nav {
		&:link,
		&:visited {
			color: ${({ theme: { nav } }) => nav.menuActiveText};
			&::after {
				transform: scaleX(1);
			}
		}
	}

	&:hover {
		color: ${({ theme: { nav } }) => nav.menuActiveText};
	}
`;

const List = styled.ul`
	list-style: none;
	display: flex;

	${({ dropdown }) =>
		dropdown &&
		css`
			${customResponsive(
				1365,
				css`
					display: none;
				`
			)}
		`}

	${applyStyleModifiers(LIST_MODIFIERS)};
`;

const Item = styled.li`
	display: flex;

	${applyStyleModifiers(ITEM_MODIFIERS)};
`;

const NavLink = styled(RouterNavLink)`
	${linkStyle}

	${({ inverse }) =>
		inverse &&
		css`
			&.active-nav {
				&:link,
				&:visited {
					color: ${({ theme }) => theme.white};
				}
			}
		`}

	${applyStyleModifiers(NAV_LINK_MODIFIERS)};
`;

const Link = styled(RouterLink)`
	${linkStyle}
`;

export { List, Item, NavLink, Link };
